// extracted by mini-css-extract-plugin
module.exports = {"licensePlate":"styles_licensePlate__1glQD"};